<template>
  <div class="content">
    {{ $t(notification.message, notification.replacements) }}
    <a v-if="notification.link_type == 'external'" :href="$t(notification.link)" target="_blank" rel="noopener"
      :class="notification.link_class">
      <span v-if="notification.link_text">{{ $t(notification.link_text) }}</span>
      <i v-if="notification.link_icon" :class='notification.link_icon' aria-hidden="true"></i>
    </a>
    <router-link v-else :to="$t(notification.link)" :class="notification.link_class">
      <span v-if="notification.link_text">{{ $t(notification.link_text) }}</span>
      <i v-if="notification.link_icon" :class='notification.link_icon' aria-hidden="true"></i>
    </router-link>
  </div>
</template>
<script setup>
import { defineProps } from 'vue';

defineProps({
  notification: Object
});
</script>
